// Module
var code = "<avi-state-page> <avi-state-page_main-content> <collection-grid config=\"$ctrl.gridConfig\"></collection-grid> </avi-state-page_main-content> </avi-state-page> ";
// Exports
export default code;